import React from "react";

const Footer = () => {
    return (
        <footer>
            <div className="footer-bottom">

            </div>
        </footer>
    )
}

export default Footer;